"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationBroadbands = require("../../../hooks/recommendation/useRecommendationBroadbands");
var _r10SourceLibrary = require("r10-source-library");
var _UpsellBreakdown = _interopRequireDefault(require("../../Upsell/UpsellBreakdown"));
var _UpsellBreakdownWrapper = _interopRequireDefault(require("../../Upsell/UpsellBreakdownWrapper"));
var _DynamicRecommendationBroadband = _interopRequireDefault(require("./DynamicRecommendationBroadband"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationBroadband = () => {
  const {
    recommendedBroadband,
    premiumBroadband,
    budgetBroadband,
    alternativePremiumBroadband,
    alternativeBudgetBroadband,
    selectedBroadband
  } = (0, _useRecommendationBroadbands.useRecommendationBroadbands)();
  const broadbands = [recommendedBroadband, premiumBroadband, alternativePremiumBroadband, alternativeBudgetBroadband, budgetBroadband].filter(broadband => broadband);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "recommendation-broadband-id"
  }, /*#__PURE__*/_react.default.createElement(_DynamicRecommendationBroadband.default, {
    broadbands: broadbands,
    selectedBroadband: selectedBroadband
  }), /*#__PURE__*/_react.default.createElement(_UpsellBreakdownWrapper.default, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, null, /*#__PURE__*/_react.default.createElement(_UpsellBreakdown.default, null)))));
};
var _default = RecommendationBroadband;
exports.default = _default;